import React, { useState } from 'react';
import SectionHeader from '../SectionHeader';
import EmptyState from '../EmptyState';
import CharacterCard from '../CharacterCard';
import { motion } from 'framer-motion';

export default function CharacterTab({ characters, keepsakes, onOpenModal, onRefresh }) {
  const [showHidden, setShowHidden] = useState(false);
  const hiddenCount = characters.filter(c => c.is_hidden).length;
  const visibleCharacters = characters.filter(c => showHidden ? true : !c.is_hidden);

  return (
    <div>
      <SectionHeader 
        title="Characters" 
        description="Everyone who walks through Haeth" 
        buttonText="New Character"
        onButtonClick={() => onOpenModal()} 
      />

      {hiddenCount > 0 && (
        <div className="flex justify-end mb-4 pr-4">
          <button 
            onClick={() => setShowHidden(!showHidden)}
            className="font-lora text-[0.8rem] italic text-ink-light hover:text-ink transition-colors underline decoration-dashed underline-offset-4"
          >
            {showHidden ? `Hide archived characters` : `Show ${hiddenCount} hidden character${hiddenCount !== 1 ? 's' : ''}`}
          </button>
        </div>
      )}

      {visibleCharacters.length === 0 ? (
        <EmptyState icon="🎭" title="No characters yet." hint="Add yours to begin." />
      ) : (
        <div className="grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-6 pl-4">
          {visibleCharacters.map((char, i) => (
            <motion.div 
              key={char.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay: i * 0.05 }}
            >
              <CharacterCard 
                char={char} 
                keepsakes={keepsakes} 
                onEdit={() => onOpenModal(char)} 
                onRefresh={onRefresh}
              />
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}